// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'

Vue.use(ElementUI);

import { Message } from 'element-ui';
//定义一个新的Message方法，多传入一个offset参数
const $message = options => {
  return Message({
    ...options,
    offset: 100
  });
};

//重写一遍success的方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 100
      };
    }
    options.type = type;
    return Message(options);
  };
});
//将$message挂载到this上
Vue.prototype.$message = $message;


import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

Vue.use(vueSwiper);

import axios from 'axios';
//axios
Vue.prototype.$axios = axios;

//global
import GLOBAL from '@/assets/js/global.js';
Vue.prototype.$global = GLOBAL;
Vue.prototype.$ajax_url_map = GLOBAL.ajax_url_map;
Vue.prototype.$ajax_code = GLOBAL.ajax_states;

//login
import mslogin from '@/assets/js/msLogin.js';
Vue.prototype.$mslogin = mslogin;
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login;

//Pin
import Pin from 'vue-pin'
// install
Vue.use(Pin)

//entrance
import Entrance_Modal from '@/components/entranceModal';
Vue.prototype.$entrance = Entrance_Modal;

//success
import Success_Modal from '@/components/successModal';
Vue.prototype.$success_modal = Success_Modal;

//join
import Join_Modal from '@/components/joinModal';
Vue.prototype.$join_modal = Join_Modal;

//member-list
import List_Modal from '@/components/memberModal';
Vue.prototype.$list_modal = List_Modal;

//add
import Add_Modal from '@/components/addMemberModal';
Vue.prototype.$add_modal = Add_Modal;

Vue.prototype.$ua_update = function(data){
  mainApp.ua.role = data.role;
  mainApp.ua.state = data.state;
};

Vue.config.productionTip = false;

/* eslint-disable no-new */
const mainApp = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App :ready="config_ready" :ua="ua" :login="login"/>',
  data (){
    return {
      config_ready : true,
      ua : {},//role 1:队长 2：队员 3：游客  state 是否确认
      login : 0,
    }
  },
  created () {
    var self = this;

    var instance = axios.create();
    instance.defaults.timeout = 1000 * 20;
    instance.defaults.headers.post['Content-Type'] = 'application/json';
    instance.defaults.headers['withCredentials'] = true;
    axios.defaults.crossDomain=true;
    axios.defaults.withCredentials= true;//跨域带cookie

    /* 请求拦截 */
    this.$axios.interceptors.request.use(
        config => {

            config.headers["Activity-Id"] = GLOBAL.ActivityId;
            
            return config;
        },
        err => Promise.reject(err)
    );

    //请求返回拦截
    this.$axios.interceptors.response.use((response) => {
        if (response.data.code === 2) {
            //其余错误状态处理

        }
        else if(response.data.code === 401) {
            //未登录
            
        }

        return response;

    }, function (error) {
        return Promise.reject(error);
    });

    //self.config_ready = true;
    //this.init_userifo();
    this.userLogin();
  },
  mounted () {
    
  },
  methods :{
    init_userifo() {
      var _this = this;
      // $.ajax({
      //   type: "get",
      //   url: this.$ajax_url_map.userInfo,
      //   dataType: "json",
      //   data: {
      //       'r': new Date().getTime()
      //   },
      //   success: function (res) {
      //     console.log(res.data);
      //     if(res.code == _this.$ajax_code.success){
      //         _this.ua = res.data;
      //         _this.login = 1;
      //     }
      //   },
      //   error: function () {
      //       //Toast.error('请稍后再试');
      //   }
    //});
    },
    userLogin(){
      this.$axios({
          method: 'get',
          url: this.$ajax_url_map.userInfo,
          data:{
              '_': +new Date(),
          },
          withCredentials: true,
          responseType: 'json',
      })
      .then(res=>{
          console.log(res.data);
          if(res.data.code == this.$ajax_code.success){
              this.ua = res.data.data;
              this.login = 1;
          }
      })
      .catch(err=>{
          console.error(err);
      })
  },    
  }, 
})



// WEBPACK FOOTER //
// ./src/main.js